import { colors } from '@ardoq/design-tokens';

/**
 * Which token each part of the chart is drawn in.
 *
 * Named rather than inline so a test can hold them. The grid is not among them: it is a fraction of
 * the ink over whatever plane it is drawn on (`gridStroke`), because three attempts at picking a
 * grey for it failed - `borderSubtle` was invisible at 1.11:1, and `borderNeutral` has no dark-mode
 * value at all, so it stays `grey300` on a `grey900` panel and would have been the brightest line
 * in the chart.
 *
 * `gridColor` survives under that name for the one thing that is still a border: the outline of the
 * hover tooltip in `renderSamples`. `borderSubtle` is right for that and has a dark value.
 */
export const SURFACE_3D_COLOR_TOKENS = {
  surface: colors.surfaceDefault,
  ink: colors.textDefault,
  border: colors.borderSubtle,
  panel: colors.surfaceDefaultSubtle,
} as const;
